import React, { useEffect } from 'react'
import { MenuItem, TextField, SxProps, Theme } from '@mui/material'
import { useTypePosition } from '../../hooks'
import { TypePosition } from '../../interfaces/TypePosition'

interface TypePositionDDLProps {
  onChange: any
  value: any
  withoutThisPositions?: number[]
  fullWidth?: boolean
  variant?: 'outlined' | 'standard' | 'filled'
  size?: 'small' | 'medium' | undefined
  sx?: SxProps<Theme>
}

export const TypePositionDDL: React.FC<TypePositionDDLProps> = ({
  onChange,
  value,
  withoutThisPositions = [],
  fullWidth = false,
  variant = 'standard',
  size,
  ...otherProps
}) => {
  const {
    typePositionsState: { typePositions },
    getTypePositions
  } = useTypePosition()

  useEffect(() => {
    if (typePositions?.length === 0) {
      getTypePositions()
    }
  }, [])

  const arrTypePositions =
    typePositions !== undefined
      ? typePositions
          .filter((item) => !withoutThisPositions.includes(item.typePositionId))
          .map((option: TypePosition) => (
            <MenuItem key={option.typePositionId} value={option.typePositionId}>
              {option.typePositionDescription}
            </MenuItem>
          ))
      : []

  return (
    <TextField
      id='typePositionId'
      name='typePositionId'
      select
      value={value === '' ? -1 : value}
      onChange={onChange}
      fullWidth={fullWidth}
      variant={variant}
      size={size}
      {...otherProps}
    >
      <MenuItem key={-1} value={-1}>
        {'Seleccionar Tipo Posición...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
